/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snackbar_WarningInputs */

const en_snackbar_warning = /** @type {(inputs: Snackbar_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warning`)
};

const de_snackbar_warning = /** @type {(inputs: Snackbar_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnung`)
};

/**
* | output |
* | --- |
* | "Warning" |
*
* @param {Snackbar_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const snackbar_warning = /** @type {((inputs?: Snackbar_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_warning(inputs)
	return de_snackbar_warning(inputs)
});